import React, { Fragment, useCallback, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { clone, isEmpty } from "ramda";
import { logOut } from "../../../auth/authActions";
import { useHistory } from "react-router-dom";

import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import AddIcon from "@material-ui/icons/Add";

import AnthologyTable from "./AnthologyTable";
import MediaBrowser from "../../common/MediaBrowser";
import SearchBar from "../../common/SearchBar";
import TotalsHeader from "../../common/TotalsHeader";
import AddNewAnthologyDialog from "./AddNewAnthologyDialog";
import AddMediaToParentDropDown from "../../common/AddMediaToParentDropdown";
import SnackAlert from "../../../components/SnackAlert";
import { useSnackAlert } from "../../../common/use-snackAlert";
import { useSearchQuery } from "../../common/use-searchQuery";

const AnthologyBrowser = props => {
  const {
    searchState,
    onSearchStateChange,
    searchResults,
    onSaveSuccess,
  } = props;
  const [scrollVisible, setScrollVisible] = useState(true);
  const [anthologiesSelected, setAnthologiesSelected] = useState([]);

  const reduxDispatch = useDispatch();
  const history = useHistory();

  //-- Handle Search state
  const initialState = clone(searchState);
  const {
    state,
    handleUpdateSort,
    handleUpdateQuery,
    handleUpdatePage,
  } = useSearchQuery(initialState);

  //-- Whenever the internal search state changes, update the search state stored in the parent
  useEffect(() => {
    onSearchStateChange(state);
    setScrollVisible(true);
  }, [onSearchStateChange, state]);

  //TODO: Should probably move this up to View
  useEffect(() => {
    if (searchResults.error) {
      //-- Send user to login if the token has expired or not logged in
      if (searchResults.error.status === 401) {
        reduxDispatch(logOut());
      }
    }
  }, [searchResults.error, reduxDispatch]);

  //-- Manage the alert message
  // const { SnackAlert, showAlert } = useSnackAlert();
  const snackAlertHandler = useSnackAlert();
  const { showAlert } = snackAlertHandler;

  const handleScrollVisible = useCallback(visible => {
    setScrollVisible(visible);
  }, []);

  const [disableAddToModule, setDisableAddToModule] = useState(true);

  const handleSelectChange = useCallback(selected => {
    setDisableAddToModule(isEmpty(selected));
    setAnthologiesSelected(selected);
  }, []);

  const [open, setOpen] = useState(false);
  const openNewAnthologyDialog = () => setOpen(true);
  const onClose = () => setOpen(false);
  const closeNewAnthologyDialog = ({ redirectPath, newAnthologyId }) => {
    setOpen(false);
    history.push(`${redirectPath}/${newAnthologyId}`);
  };

  return (
    <Fragment>
      <SnackAlert handler={snackAlertHandler} />
      <AddNewAnthologyDialog
        open={open}
        onSave={closeNewAnthologyDialog}
        onClose={onClose}
      />
      <MediaBrowser
        loaded={searchResults.isSuccess}
        scrollVisible={scrollVisible}
        searchBar={
          <SearchBar
            query={state.appliedQuery}
            onQueryChange={handleUpdateQuery}
          />
        }
        totalsHeader={
          <TotalsHeader
            countText="Anthology"
            count={
              searchResults.isSuccess ? searchResults.data.totalCount : "-"
            }
            selectedActions={
              <Grid container alignItems="center">
                <Button
                  variant="text"
                  startIcon={<AddIcon />}
                  onClick={openNewAnthologyDialog}
                >
                  New Anthology
                </Button>
                <AddMediaToParentDropDown
                  parent="module"
                  disableButton={disableAddToModule}
                  childList={anthologiesSelected}
                  showAlert={showAlert}
                  handleAddSuccess={onSaveSuccess}
                />
              </Grid>
            }
          />
        }
        mediaTable={
          <AnthologyTable
            searchState={searchState}
            anthologyList={
              searchResults.isSuccess ? searchResults.data.media : []
            }
            total={searchResults.isSuccess ? searchResults.data.totalCount : 0}
            page={state.page}
            orderBy={state.orderBy}
            order={state.orderDirection}
            onSortChange={handleUpdateSort}
            onPageChange={handleUpdatePage}
            onSelectChange={handleSelectChange}
            onScrollVisible={handleScrollVisible}
          />
        }
      />
    </Fragment>
  );
};

export default AnthologyBrowser;
